import { axiosRequestPOST } from './serviceConfig';

export const getVersionsService = (champResourceIds = []) =>
  axiosRequestPOST('/api/versions', champResourceIds);
